import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import env from '../../../../config/env';

export default function LocationAlertTutorialLink() {
  const { t } = useTranslation(['button', 'description']);

  return (
    <Alert variant="outlined" severity="warning" icon={false} sx={{ mb: 1.5 }}>
      {t('orders.deliver.location_attempt_failed', { ns: 'description' })}{' '}
      <a
        href={env.TUTORIAL_LOCATION_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('follow_tutorial', { ns: 'button' })}
      </a>
    </Alert>
  );
}
